/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Ampli - A strong typed wrapper for your Analytics
 *
 * This file is generated by Amplitude.
 * To update run 'ampli pull web'
 *
 * Required dependencies: @amplitude/analytics-browser@^1.3.0
 * Tracking Plan Version: 3
 * Build: 1.0.0
 * Runtime: browser:typescript-ampli-v2
 *
 * [View Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest)
 *
 * [Full Setup Instructions](https://data.amplitude.com/novantwrk/NOVA/implementation/web)
 */

import * as amplitude from '@amplitude/analytics-browser';

export type Environment = 'production' | 'development';

export const ApiKey: Record<Environment, string> = {
  production: 'd80c0e3207743ab0d6cb5eb37bd1c866',
  development: '6cf5250f6fc2ef961f834d16f30b69a0'
};

/**
 * Default Amplitude configuration options. Contains tracking plan information.
 */
export const DefaultConfiguration: BrowserOptions = {
  plan: {
    version: '3',
    branch: 'main',
    source: 'web',
    versionId: '14a98ac4-ba3f-4874-afc4-f3dd959c47e7'
  },
  ...{
    ingestionMetadata: {
      sourceName: 'browser-typescript-ampli',
      sourceVersion: '2.0.0'
    }
  }
};

export interface LoadOptionsBase { disabled?: boolean }

export type LoadOptionsWithEnvironment = LoadOptionsBase & { environment: Environment; client?: { configuration?: BrowserOptions; }; };
export type LoadOptionsWithApiKey = LoadOptionsBase & { client: { apiKey: string; configuration?: BrowserOptions; } };
export type LoadOptionsWithClientInstance = LoadOptionsBase & { client: { instance: BrowserClient; } };

export type LoadOptions = LoadOptionsWithEnvironment | LoadOptionsWithApiKey | LoadOptionsWithClientInstance;

export interface IdentifyProperties {
  /**
   * This ID is created for every user that has a client application accepted on the platform and then clicks "get started" on the application acceptance screen. Clicking that will start the profile setup flow which in turn triggers the creation of the "client" entity in the backend, setting this client id. Because users can be both creatives and clients, there are some cases where a user will have both a creative and client id, but for the most part
   */
  "Client ID"?: string;
  "Client Profile Setup Date"?: string;
  /**
   * This ID is created for every user that has a creative application accepted on the platform and then clicks "get started" on the application acceptance screen. Clicking that will start the profile setup flow which in turn triggers the creation of the "creative" entity in the backend, setting this creative id.
   */
  "Creative ID"?: string;
  /**
   * The date that the user's creative profile was set up
   */
  "Creative Profile Setup Date"?: string;
  "Current Subscription Start Date"?: string;
  "Day Pass Last Purchase Date"?: string;
  email?: string;
  "First Subscription Date"?: string;
  /**
   * Numeric counter that increases each time an application is submitted successfully
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  "Job Applications Sent"?: number;
  /**
   * Numeric value that increases each time user posts a job
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  "Jobs Posted"?: number;
  "Most Recent Cancellation Date"?: string;
  "Most Recent Expiration Date"?: string;
  name?: string;
  /**
   * What pro tier is the user on? If they are not a pro user this will not be set to a value
   */
  "Pro Tier"?: string;
  "Pro User"?: boolean;
  /**
   * This integer numeric property should increase each time a user successfully posts a project
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  "Projects Posted"?: number;
  /**
   * Where the user purchased a subscription - Web or iOS
   */
  "Purchase Origin"?: string;
  "Recurring Subscription Plan"?: string;
  "Recurring Subscription Status"?: string;
  /**
   * Values = {apple, phone number}
   *
   * Set on "sign up complete" event
   */
  "Sign Up Method"?: string;
  Trial?: boolean;
  "Trial Start Date"?: string;
  username?: string;
}

export interface AccountAddSocialCancelProperties {
  /**
   * This property records if the event was trigged inside the creative hub or the client hub
   *  Possible values: creative, client
   */
  account_type?: string;
  /**
   * This property is used for events that have mutliple different entry points within the UI. For example, you can send a connection request to someone through accessing their profile OR if a creative is suggested to you in your network page
   */
  entry_point: string;
  /**
   * Potential values: Instagram, LinkedIn, Vimeo, Dribbble
   */
  social_account_type?: string;
}

export interface AccountAddSocialCompleteProperties {
  /**
   * This property records if the event was trigged inside the creative hub or the client hub
   *  Possible values: creative, client
   */
  account_type?: string;
  /**
   * This property is used for events that have mutliple different entry points within the UI. For example, you can send a connection request to someone through accessing their profile OR if a creative is suggested to you in your network page
   */
  entry_point: string;
  /**
   * Potential values: Instagram, LinkedIn, Vimeo, Dribbble
   */
  social_account_type?: string;
}

export interface AccountAddSocialStartProperties {
  /**
   * This property records if the event was trigged inside the creative hub or the client hub
   *  Possible values: creative, client
   */
  account_type?: string;
  /**
   * This property is used for events that have mutliple different entry points within the UI. For example, you can send a connection request to someone through accessing their profile OR if a creative is suggested to you in your network page
   */
  entry_point: string;
  /**
   * Potential values: Instagram, LinkedIn, Vimeo, Dribbble
   */
  social_account_type?: string;
}

export interface AccountTypeChooseProperties {
  action: string;
}

export interface ActiveApplicationOpenProperties {
  /**
   * Unique identifier for each job entity in the backend. Should correspond to the job id that is created in our database
   */
  job_id: string;
  status: string;
}

export interface ActiveJobCardOpenProperties {
  /**
   * Unique identifier for each job entity in the backend. Should correspond to the job id that is created in our database
   */
  job_id: string;
  status: string;
}

export interface ActiveJobCardShortcutProperties {
  /**
   * Unique identifier for each job entity in the backend. Should correspond to the job id that is created in our database
   */
  job_id: string;
  shortcut_type: string;
  status: string;
}

export interface ApplicationCompleteProperties {
  /**
   * This property records if the event was trigged inside the creative hub or the client hub
   *  Possible values: creative, client
   */
  account_type?: string;
}

export interface ApplicationContinueProperties {
  /**
   * This property records if the event was trigged inside the creative hub or the client hub
   *  Possible values: creative, client
   */
  account_type?: string;
}

export interface ApplicationDetailViewProperties {
  /**
   * This property stores the creative id of someone other than the user triggering the event. It may be used for events such as viewing someone else's profile other than one's own.
   */
  creative_id?: string;
  /**
   * This property is used for events that have mutliple different entry points within the UI. For example, you can send a connection request to someone through accessing their profile OR if a creative is suggested to you in your network page
   */
  entry_point: string;
  /**
   * Unique identifier for each job entity in the backend. Should correspond to the job id that is created in our database
   */
  job_id: string;
  status: string;
  view_mode: string;
}

export interface ApplicationEditProperties {
  /**
   * This property records if the event was trigged inside the creative hub or the client hub
   *  Possible values: creative, client
   */
  account_type?: string;
}

export interface ApplicationExitProperties {
  /**
   * This property records if the event was trigged inside the creative hub or the client hub
   *  Possible values: creative, client
   */
  account_type?: string;
  /**
   * This property is used on "exit" events to capture the screen where the exit took place
   */
  last_screen?: string;
}

export interface ApplicationGoToChatProperties {
  /**
   * This property stores the creative id of someone other than the user triggering the event. It may be used for events such as viewing someone else's profile other than one's own.
   */
  creative_id?: string;
  /**
   * This property is used for events that have mutliple different entry points within the UI. For example, you can send a connection request to someone through accessing their profile OR if a creative is suggested to you in your network page
   */
  entry_point: string;
  /**
   * Unique identifier for each job entity in the backend. Should correspond to the job id that is created in our database
   */
  job_id: string;
  status: string;
  view_mode: string;
}

export interface ApplicationMarkInterestedProperties {
  /**
   * This property stores the creative id of someone other than the user triggering the event. It may be used for events such as viewing someone else's profile other than one's own.
   */
  creative_id?: string;
  /**
   * This property is used for events that have mutliple different entry points within the UI. For example, you can send a connection request to someone through accessing their profile OR if a creative is suggested to you in your network page
   */
  entry_point: string;
  /**
   * Unique identifier for each job entity in the backend. Should correspond to the job id that is created in our database
   */
  job_id: string;
  status: string;
  view_mode: string;
}

export interface ApplicationMarkPassedProperties {
  /**
   * This property stores the creative id of someone other than the user triggering the event. It may be used for events such as viewing someone else's profile other than one's own.
   */
  creative_id?: string;
  /**
   * This property is used for events that have mutliple different entry points within the UI. For example, you can send a connection request to someone through accessing their profile OR if a creative is suggested to you in your network page
   */
  entry_point: string;
  /**
   * Unique identifier for each job entity in the backend. Should correspond to the job id that is created in our database
   */
  job_id: string;
  status: string;
  view_mode: string;
}

export interface ApplicationSetDetailProperties {
  step: string;
}

export interface ApplicationStartProperties {
  /**
   * This property records if the event was trigged inside the creative hub or the client hub
   *  Possible values: creative, client
   */
  account_type?: string;
}

export interface ApplicationStartAChatProperties {
  /**
   * This property stores the creative id of someone other than the user triggering the event. It may be used for events such as viewing someone else's profile other than one's own.
   */
  creative_id?: string;
  /**
   * This property is used for events that have mutliple different entry points within the UI. For example, you can send a connection request to someone through accessing their profile OR if a creative is suggested to you in your network page
   */
  entry_point: string;
  /**
   * Unique identifier for each job entity in the backend. Should correspond to the job id that is created in our database
   */
  job_id: string;
  status: string;
  view_mode: string;
}

export interface ApplicationUnmarkInterestedProperties {
  /**
   * This property stores the creative id of someone other than the user triggering the event. It may be used for events such as viewing someone else's profile other than one's own.
   */
  creative_id?: string;
  /**
   * This property is used for events that have mutliple different entry points within the UI. For example, you can send a connection request to someone through accessing their profile OR if a creative is suggested to you in your network page
   */
  entry_point: string;
  /**
   * Unique identifier for each job entity in the backend. Should correspond to the job id that is created in our database
   */
  job_id: string;
  status: string;
  view_mode: string;
}

export interface ApplicationUnmarkPassedProperties {
  /**
   * This property stores the creative id of someone other than the user triggering the event. It may be used for events such as viewing someone else's profile other than one's own.
   */
  creative_id?: string;
  /**
   * This property is used for events that have mutliple different entry points within the UI. For example, you can send a connection request to someone through accessing their profile OR if a creative is suggested to you in your network page
   */
  entry_point: string;
  /**
   * Unique identifier for each job entity in the backend. Should correspond to the job id that is created in our database
   */
  job_id: string;
  status: string;
  view_mode: string;
}

export interface ApplicationsViewProperties {
  /**
   * Unique identifier for each job entity in the backend. Should correspond to the job id that is created in our database
   */
  job_id: string;
  status: string;
  view_type: string;
}

export interface ApplyToJobCompleteProperties {
  /**
   * Unique identifier for each job entity in the backend. Should correspond to the job id that is created in our database
   */
  job_id: string;
  /**
   * Values: Creative, Client
   */
  job_type: string;
}

export interface ApplyToJobStartProperties {
  /**
   * Unique identifier for each job entity in the backend. Should correspond to the job id that is created in our database
   */
  job_id: string;
  /**
   * Values: Creative, Client
   */
  job_type: string;
}

export interface ArchivedApplicationOpenProperties {
  /**
   * Unique identifier for each job entity in the backend. Should correspond to the job id that is created in our database
   */
  job_id: string;
  status: string;
}

export interface BenefitsModalInteractionProperties {
  action: string;
}

export interface BusinessCardViewMoreWorkProperties {
  /**
   * This property is used for events that have mutliple different entry points within the UI. For example, you can send a connection request to someone through accessing their profile OR if a creative is suggested to you in your network page
   */
  entry_point: string;
}

export interface BusinessCardViewProfileProperties {
  /**
   * This property is used for events that have mutliple different entry points within the UI. For example, you can send a connection request to someone through accessing their profile OR if a creative is suggested to you in your network page
   */
  entry_point: string;
}

export interface ChatMessageSendProperties {
  /**
   * This property records if the event was trigged inside the creative hub or the client hub
   *  Possible values: creative, client
   */
  account_type?: string;
  chat_type: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Unique Items | true |
   * | Item Type | string |
   */
  user_id?: string[];
}

export interface ChatStartProperties {
  /**
   * This property records if the event was trigged inside the creative hub or the client hub
   *  Possible values: creative, client
   */
  account_type?: string;
  /**
   * This property is used for events that have mutliple different entry points within the UI. For example, you can send a connection request to someone through accessing their profile OR if a creative is suggested to you in your network page
   */
  entry_point: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Unique Items | true |
   * | Item Type | string |
   */
  user_id?: string[];
}

export interface ConnectionRequestAcceptProperties {
  /**
   * This property is used for events that have mutliple different entry points within the UI. For example, you can send a connection request to someone through accessing their profile OR if a creative is suggested to you in your network page
   */
  entry_point: string;
  screen_name?: any;
}

export interface ConnectionRequestSendProperties {
  /**
   * This property is used for events that have mutliple different entry points within the UI. For example, you can send a connection request to someone through accessing their profile OR if a creative is suggested to you in your network page
   */
  entry_point: string;
  is_contact?: boolean;
  screen_name?: any;
}

export interface DetailsTabViewProperties {
  /**
   * Unique identifier for each job entity in the backend. Should correspond to the job id that is created in our database
   */
  job_id: string;
  status: string;
}

export interface DiscoverCategoryViewAllProperties {
  shortcut_type: string;
}

export interface DiscoverFilterApplyProperties {
  /**
   * This property is used for events that have mutliple different entry points within the UI. For example, you can send a connection request to someone through accessing their profile OR if a creative is suggested to you in your network page
   */
  entry_point: string;
  /**
   * Type of filter for jobs and on discover page - ex. position, location, date, etc.
   */
  filter_type: string;
  /**
   * Value applied to a filter type for jobs and discover page. For example, for filtetype = position, a filter_value may be photographer
   */
  filter_value: string;
}

export interface DiscoverKeywordSearchProperties {
  /**
   * This property records if the event was trigged inside the creative hub or the client hub
   *  Possible values: creative, client
   */
  account_type?: string;
  /**
   * Keyword typed into searchbar
   */
  search_term?: string;
}

export interface DiscoverResultsViewToggleProperties {
  from: any;
  to?: any;
}

export interface DiscoverShortcutSearchProperties {
  shortcut_type: string;
  shortcut_value?: string;
}

export interface EmailNotificationLinkClickProperties {
  link_type: string;
  /**
   * Unique identifier automatically created and assigned to a notification once the backend creates it and sends it out
   */
  notification_id: string;
  /**
   * Definition: This property stores the type of notification
   *
   * Values: JobApplicationReceived, ConnectionRequestReceived, ProjectLiked,etc.
   */
  notification_type: string;
}

export interface EmailNotificationOpenProperties {
  /**
   * Unique identifier automatically created and assigned to a notification once the backend creates it and sends it out
   */
  notification_id: string;
  /**
   * Definition: This property stores the type of notification
   *
   * Values: JobApplicationReceived, ConnectionRequestReceived, ProjectLiked,etc.
   */
  notification_type: string;
}

export interface EntryActionChooseProperties {
  action: string;
}

export interface FeaturedListViewProperties {
  /**
   * This property is used for events that have mutliple different entry points within the UI. For example, you can send a connection request to someone through accessing their profile OR if a creative is suggested to you in your network page
   */
  entry_point: string;
}

export interface InviteToJobCompleteProperties {
  /**
   * This property records if the event was trigged inside the creative hub or the client hub
   *  Possible values: creative, client
   */
  account_type?: string;
  /**
   * This property is used for events that have mutliple different entry points within the UI. For example, you can send a connection request to someone through accessing their profile OR if a creative is suggested to you in your network page
   */
  entry_point: string;
  /**
   * Unique identifier for each job entity in the backend. Should correspond to the job id that is created in our database
   */
  job_id: string;
  /**
   * Values: Creative, Client
   */
  job_type: string;
}

export interface InviteToJobExitProperties {
  /**
   * This property records if the event was trigged inside the creative hub or the client hub
   *  Possible values: creative, client
   */
  account_type?: string;
  /**
   * This property is used for events that have mutliple different entry points within the UI. For example, you can send a connection request to someone through accessing their profile OR if a creative is suggested to you in your network page
   */
  entry_point: string;
  /**
   * Unique identifier for each job entity in the backend. Should correspond to the job id that is created in our database
   */
  job_id: string;
}

export interface InviteToJobStartProperties {
  /**
   * This property records if the event was trigged inside the creative hub or the client hub
   *  Possible values: creative, client
   */
  account_type?: string;
  /**
   * This property is used for events that have mutliple different entry points within the UI. For example, you can send a connection request to someone through accessing their profile OR if a creative is suggested to you in your network page
   */
  entry_point: string;
}

export interface InvitesViewProperties {
  /**
   * Unique identifier for each job entity in the backend. Should correspond to the job id that is created in our database
   */
  job_id: string;
  status: string;
}

export interface JobCardClickProperties {
  /**
   * Unique identifier for each job entity in the backend. Should correspond to the job id that is created in our database
   */
  job_id: string;
  redacted: boolean;
}

export interface JobChatStartProperties {
  /**
   * This property records if the event was trigged inside the creative hub or the client hub
   *  Possible values: creative, client
   */
  account_type?: string;
  chat_id: string;
  /**
   * This property stores the creative id of someone other than the user triggering the event. It may be used for events such as viewing someone else's profile other than one's own.
   */
  creative_id?: string;
  /**
   * Unique identifier for each job entity in the backend. Should correspond to the job id that is created in our database
   */
  job_id: string;
}

export interface JobChatViewProperties {
  /**
   * This property stores the creative id of someone other than the user triggering the event. It may be used for events such as viewing someone else's profile other than one's own.
   */
  creative_id?: string;
  /**
   * Unique identifier for each job entity in the backend. Should correspond to the job id that is created in our database
   */
  job_id: string;
}

export interface JobDetailViewProperties {
  /**
   * This property is used for events that have mutliple different entry points within the UI. For example, you can send a connection request to someone through accessing their profile OR if a creative is suggested to you in your network page
   */
  entry_point: string;
  /**
   * Unique identifier for each job entity in the backend. Should correspond to the job id that is created in our database
   */
  job_id: string;
  redacted: boolean;
}

export interface JobFilterApplyProperties {
  /**
   * Type of filter for jobs and on discover page - ex. position, location, date, etc.
   */
  filter_type: string;
  /**
   * Value applied to a filter type for jobs and discover page. For example, for filtetype = position, a filter_value may be photographer
   */
  filter_value: string;
}

export interface JobFilterClickProperties {
  /**
   * Type of filter for jobs and on discover page - ex. position, location, date, etc.
   */
  filter_type: string;
}

export interface JobPostCloseProperties {
  /**
   * This property records if the event was trigged inside the creative hub or the client hub
   *  Possible values: creative, client
   */
  account_type?: string;
  /**
   * This property is used for events that have mutliple different entry points within the UI. For example, you can send a connection request to someone through accessing their profile OR if a creative is suggested to you in your network page
   */
  entry_point: string;
  /**
   * Unique identifier for each job entity in the backend. Should correspond to the job id that is created in our database
   */
  job_id: string;
  status: string;
}

export interface JobVisibilityToggleProperties {
  action: string;
  /**
   * Unique identifier for each job entity in the backend. Should correspond to the job id that is created in our database
   */
  job_id: string;
  status: string;
}

export interface ManageTabViewProperties {
  /**
   * Unique identifier for each job entity in the backend. Should correspond to the job id that is created in our database
   */
  job_id: string;
  status: string;
}

export interface MessagesViewProperties {
  /**
   * Unique identifier for each job entity in the backend. Should correspond to the job id that is created in our database
   */
  job_id: string;
  status: string;
}

export interface NavigationProperties {
  /**
   * This property records if the event was trigged inside the creative hub or the client hub
   *  Possible values: creative, client
   */
  account_type?: string;
  from: any;
  to?: any;
}

export interface NewInviteSearchCompleteProperties {
  /**
   * Unique identifier for each job entity in the backend. Should correspond to the job id that is created in our database
   */
  job_id: string;
  status: string;
}

export interface NewInviteSearchStartProperties {
  /**
   * Unique identifier for each job entity in the backend. Should correspond to the job id that is created in our database
   */
  job_id: string;
  status: string;
}

export interface NewInviteSuggestedCreativeProperties {
  /**
   * This property is used for events that have mutliple different entry points within the UI. For example, you can send a connection request to someone through accessing their profile OR if a creative is suggested to you in your network page
   */
  entry_point: string;
  /**
   * Unique identifier for each job entity in the backend. Should correspond to the job id that is created in our database
   */
  job_id: string;
  status: string;
}

export interface NoAttachedWorkWarningProperties {
  action: string;
}

export interface NotificationOpenProperties {
  /**
   * Definition: This property stores the type of notification
   *
   * Values: JobApplicationReceived, ConnectionRequestReceived, ProjectLiked,etc.
   */
  notification_type: string;
}

export interface PlanSelectProperties {
  free_trial: boolean;
  plan_length: string;
}

export interface PlanSelectionScreenExitProperties {
  /**
   * This property is used for events that have mutliple different entry points within the UI. For example, you can send a connection request to someone through accessing their profile OR if a creative is suggested to you in your network page
   */
  entry_point: string;
}

export interface PlanSelectionScreenViewProperties {
  /**
   * This property is used for events that have mutliple different entry points within the UI. For example, you can send a connection request to someone through accessing their profile OR if a creative is suggested to you in your network page
   */
  entry_point: string;
}

export interface PostAJobErrorProperties {
  /**
   * This property records if the event was trigged inside the creative hub or the client hub
   *  Possible values: creative, client
   */
  account_type?: string;
  /**
   * This property stores the fields that can be added to a job post
   *
   * Values:position, location, date, title, description, job type, project type, pay, skills
   */
  job_post_field?: string;
}

export interface PostAJobExitProperties {
  /**
   * This property records if the event was trigged inside the creative hub or the client hub
   *  Possible values: creative, client
   */
  account_type?: string;
  /**
   * Unique identifier for each job entity in the backend. Should correspond to the job id that is created in our database
   */
  job_id: string;
}

export interface PostAJobPublishProperties {
  /**
   * This property records if the event was trigged inside the creative hub or the client hub
   *  Possible values: creative, client
   */
  account_type?: string;
  /**
   * Unique identifier for each job entity in the backend. Should correspond to the job id that is created in our database
   */
  job_id: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  num_suggestions: number;
}

export interface PostAJobSaveDraftProperties {
  /**
   * This property records if the event was trigged inside the creative hub or the client hub
   *  Possible values: creative, client
   */
  account_type?: string;
  /**
   * Unique identifier for each job entity in the backend. Should correspond to the job id that is created in our database
   */
  job_id: string;
}

export interface PostAJobSetDetailProperties {
  /**
   * This property records if the event was trigged inside the creative hub or the client hub
   *  Possible values: creative, client
   */
  account_type?: string;
  /**
   * Unique identifier for each job entity in the backend. Should correspond to the job id that is created in our database
   */
  job_id: string;
  /**
   * This property stores the fields that can be added to a job post
   *
   * Values:position, location, date, title, description, job type, project type, pay, skills
   */
  job_post_field?: string;
  job_post_field_value: string;
}

export interface PostAJobStartProperties {
  /**
   * This property records if the event was trigged inside the creative hub or the client hub
   *  Possible values: creative, client
   */
  account_type?: string;
  /**
   * This property is used for events that have mutliple different entry points within the UI. For example, you can send a connection request to someone through accessing their profile OR if a creative is suggested to you in your network page
   */
  entry_point: string;
  /**
   * Unique identifier for each job entity in the backend. Should correspond to the job id that is created in our database
   */
  job_id: string;
}

export interface PostAProjectPublishProperties {
  /**
   * Unique identifier of a project posted by a creative. Should correspond to what is in the backend
   */
  project_id?: string;
}

export interface PostAProjectSetDetailProperties {
  /**
   * Field value in a form
   */
  field?: string;
}

export interface PostAProjectStartProperties {
  /**
   * This property is used for events that have mutliple different entry points within the UI. For example, you can send a connection request to someone through accessing their profile OR if a creative is suggested to you in your network page
   */
  entry_point: string;
}

export interface ProfileAboutViewProperties {
  /**
   * This property records if the event was trigged inside the creative hub or the client hub
   *  Possible values: creative, client
   */
  account_type?: string;
  client_id?: string;
  /**
   * This property stores the creative id of someone other than the user triggering the event. It may be used for events such as viewing someone else's profile other than one's own.
   */
  creative_id?: string;
}

export interface ProfileLinkClickProperties {
  /**
   * This property records if the event was trigged inside the creative hub or the client hub
   *  Possible values: creative, client
   */
  account_type?: string;
  client_id?: string;
  /**
   * This property stores the creative id of someone other than the user triggering the event. It may be used for events such as viewing someone else's profile other than one's own.
   */
  creative_id?: string;
  url: string;
}

export interface ProfileSetupCompleteProperties {
  /**
   * This property records if the event was trigged inside the creative hub or the client hub
   *  Possible values: creative, client
   */
  account_type?: string;
}

export interface ProfileSetupStartProperties {
  /**
   * This property records if the event was trigged inside the creative hub or the client hub
   *  Possible values: creative, client
   */
  account_type?: string;
}

export interface ProfileViewProperties {
  /**
   * This property records if the event was trigged inside the creative hub or the client hub
   *  Possible values: creative, client
   */
  account_type?: string;
  client_id?: string;
  /**
   * This property stores the creative id of someone other than the user triggering the event. It may be used for events such as viewing someone else's profile other than one's own.
   */
  creative_id?: string;
}

export interface ProjectLikeProperties {
  /**
   * This property records if the event was trigged inside the creative hub or the client hub
   *  Possible values: creative, client
   */
  account_type?: string;
  /**
   * This property is used for events that have mutliple different entry points within the UI. For example, you can send a connection request to someone through accessing their profile OR if a creative is suggested to you in your network page
   */
  entry_point: string;
  /**
   * Unique identifier of a project posted by a creative. Should correspond to what is in the backend
   */
  project_id?: string;
}

export interface ProjectViewProperties {
  /**
   * This property records if the event was trigged inside the creative hub or the client hub
   *  Possible values: creative, client
   */
  account_type?: string;
  /**
   * This property is used for events that have mutliple different entry points within the UI. For example, you can send a connection request to someone through accessing their profile OR if a creative is suggested to you in your network page
   */
  entry_point: string;
  /**
   * Unique identifier of a project posted by a creative. Should correspond to what is in the backend
   */
  project_id?: string;
}

export interface PurchaseSubscriptionStartProperties {
  free_trial: boolean;
  plan_length: string;
}

export interface ReferralRequestAcceptProperties {
  /**
   * This property is used for events that have mutliple different entry points within the UI. For example, you can send a connection request to someone through accessing their profile OR if a creative is suggested to you in your network page
   */
  entry_point: string;
}

export interface ReferralRequestIgnoreProperties {
  /**
   * This property is used for events that have mutliple different entry points within the UI. For example, you can send a connection request to someone through accessing their profile OR if a creative is suggested to you in your network page
   */
  entry_point: string;
}

export interface ScreenViewProperties {
  /**
   * This property records if the event was trigged inside the creative hub or the client hub
   *  Possible values: creative, client
   */
  account_type?: string;
  screen_name?: any;
}

export interface SignUpStartProperties {
  sign_up_method: string;
}

export interface UpsellCardClickProperties {
  /**
   * This property is used for events that have mutliple different entry points within the UI. For example, you can send a connection request to someone through accessing their profile OR if a creative is suggested to you in your network page
   */
  entry_point: string;
}

export interface UpsellModalClickThroughProperties {
  /**
   * This property is used for events that have mutliple different entry points within the UI. For example, you can send a connection request to someone through accessing their profile OR if a creative is suggested to you in your network page
   */
  entry_point: string;
}

export interface UpsellModalExitProperties {
  /**
   * This property is used for events that have mutliple different entry points within the UI. For example, you can send a connection request to someone through accessing their profile OR if a creative is suggested to you in your network page
   */
  entry_point: string;
}

export interface UpsellModalViewProperties {
  /**
   * This property is used for events that have mutliple different entry points within the UI. For example, you can send a connection request to someone through accessing their profile OR if a creative is suggested to you in your network page
   */
  entry_point: string;
}

export interface ViewModeToggleProperties {
  action: string;
  /**
   * Unique identifier for each job entity in the backend. Should correspond to the job id that is created in our database
   */
  job_id: string;
  status: string;
}

export class Identify implements BaseEvent {
  event_type = amplitude.Types.SpecialEventType.IDENTIFY;

  constructor(
    public event_properties?: IdentifyProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class AccountAddSocialCancel implements BaseEvent {
  event_type = 'account add social cancel';

  constructor(
    public event_properties: AccountAddSocialCancelProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class AccountAddSocialComplete implements BaseEvent {
  event_type = 'account add social complete';

  constructor(
    public event_properties: AccountAddSocialCompleteProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class AccountAddSocialStart implements BaseEvent {
  event_type = 'account add social start';

  constructor(
    public event_properties: AccountAddSocialStartProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class AccountTypeChoose implements BaseEvent {
  event_type = 'account type choose';

  constructor(
    public event_properties: AccountTypeChooseProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ActiveApplicationOpen implements BaseEvent {
  event_type = 'active application open';

  constructor(
    public event_properties: ActiveApplicationOpenProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ActiveJobCardOpen implements BaseEvent {
  event_type = 'active job card open';

  constructor(
    public event_properties: ActiveJobCardOpenProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ActiveJobCardShortcut implements BaseEvent {
  event_type = 'active job card shortcut';

  constructor(
    public event_properties: ActiveJobCardShortcutProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class AddProposedRateComplete implements BaseEvent {
  event_type = 'add proposed rate complete';
}

export class AddProposedRateExit implements BaseEvent {
  event_type = 'add proposed rate exit';
}

export class AddProposedRateStart implements BaseEvent {
  event_type = 'add proposed rate start';
}

export class ApplicationComplete implements BaseEvent {
  event_type = 'application complete';

  constructor(
    public event_properties?: ApplicationCompleteProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ApplicationContinue implements BaseEvent {
  event_type = 'application continue';

  constructor(
    public event_properties?: ApplicationContinueProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ApplicationDetailView implements BaseEvent {
  event_type = 'application detail view';

  constructor(
    public event_properties: ApplicationDetailViewProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ApplicationEdit implements BaseEvent {
  event_type = 'application edit';

  constructor(
    public event_properties?: ApplicationEditProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ApplicationExit implements BaseEvent {
  event_type = 'application exit';

  constructor(
    public event_properties?: ApplicationExitProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ApplicationGoToChat implements BaseEvent {
  event_type = 'application go to chat';

  constructor(
    public event_properties: ApplicationGoToChatProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ApplicationMarkInterested implements BaseEvent {
  event_type = 'application mark interested';

  constructor(
    public event_properties: ApplicationMarkInterestedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ApplicationMarkPassed implements BaseEvent {
  event_type = 'application mark passed';

  constructor(
    public event_properties: ApplicationMarkPassedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ApplicationSetDetail implements BaseEvent {
  event_type = 'application set detail';

  constructor(
    public event_properties: ApplicationSetDetailProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ApplicationStart implements BaseEvent {
  event_type = 'application start';

  constructor(
    public event_properties?: ApplicationStartProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ApplicationStartAChat implements BaseEvent {
  event_type = 'application start a chat';

  constructor(
    public event_properties: ApplicationStartAChatProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ApplicationUnmarkInterested implements BaseEvent {
  event_type = 'application unmark interested';

  constructor(
    public event_properties: ApplicationUnmarkInterestedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ApplicationUnmarkPassed implements BaseEvent {
  event_type = 'application unmark passed';

  constructor(
    public event_properties: ApplicationUnmarkPassedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ApplicationsView implements BaseEvent {
  event_type = 'applications view';

  constructor(
    public event_properties: ApplicationsViewProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ApplyToJobComplete implements BaseEvent {
  event_type = 'apply to job complete';

  constructor(
    public event_properties: ApplyToJobCompleteProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ApplyToJobExit implements BaseEvent {
  event_type = 'apply to job exit';
}

export class ApplyToJobStart implements BaseEvent {
  event_type = 'apply to job start';

  constructor(
    public event_properties: ApplyToJobStartProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ArchivedApplicationOpen implements BaseEvent {
  event_type = 'archived application open';

  constructor(
    public event_properties: ArchivedApplicationOpenProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class BenefitsModalInteraction implements BaseEvent {
  event_type = 'benefits modal interaction';

  constructor(
    public event_properties: BenefitsModalInteractionProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class BusinessCardViewMoreWork implements BaseEvent {
  event_type = 'business card view more work';

  constructor(
    public event_properties: BusinessCardViewMoreWorkProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class BusinessCardViewProfile implements BaseEvent {
  event_type = 'business card view profile';

  constructor(
    public event_properties: BusinessCardViewProfileProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ChatMessageSend implements BaseEvent {
  event_type = 'chat message send';

  constructor(
    public event_properties: ChatMessageSendProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ChatStart implements BaseEvent {
  event_type = 'chat start';

  constructor(
    public event_properties: ChatStartProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ConnectionRequestAccept implements BaseEvent {
  event_type = 'connection request accept';

  constructor(
    public event_properties: ConnectionRequestAcceptProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ConnectionRequestSend implements BaseEvent {
  event_type = 'connection request send';

  constructor(
    public event_properties: ConnectionRequestSendProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DetailsTabView implements BaseEvent {
  event_type = 'details tab view';

  constructor(
    public event_properties: DetailsTabViewProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DiscoverCategoryViewAll implements BaseEvent {
  event_type = 'discover category view all';

  constructor(
    public event_properties: DiscoverCategoryViewAllProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DiscoverFilterApply implements BaseEvent {
  event_type = 'discover filter apply';

  constructor(
    public event_properties: DiscoverFilterApplyProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DiscoverKeywordSearch implements BaseEvent {
  event_type = 'discover keyword search';

  constructor(
    public event_properties?: DiscoverKeywordSearchProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DiscoverResultsViewToggle implements BaseEvent {
  event_type = 'discover results view toggle';

  constructor(
    public event_properties: DiscoverResultsViewToggleProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DiscoverShortcutSearch implements BaseEvent {
  event_type = 'discover shortcut search';

  constructor(
    public event_properties: DiscoverShortcutSearchProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class EmailNotificationLinkClick implements BaseEvent {
  event_type = 'email notification link click';

  constructor(
    public event_properties: EmailNotificationLinkClickProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class EmailNotificationOpen implements BaseEvent {
  event_type = 'email notification open';

  constructor(
    public event_properties: EmailNotificationOpenProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class EntryActionChoose implements BaseEvent {
  event_type = 'entry action choose';

  constructor(
    public event_properties: EntryActionChooseProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class FeaturedListView implements BaseEvent {
  event_type = 'featured list view';

  constructor(
    public event_properties: FeaturedListViewProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class InviteToJobComplete implements BaseEvent {
  event_type = 'invite to job complete';

  constructor(
    public event_properties: InviteToJobCompleteProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class InviteToJobExit implements BaseEvent {
  event_type = 'invite to job exit';

  constructor(
    public event_properties: InviteToJobExitProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class InviteToJobStart implements BaseEvent {
  event_type = 'invite to job start';

  constructor(
    public event_properties: InviteToJobStartProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class InvitesView implements BaseEvent {
  event_type = 'invites view';

  constructor(
    public event_properties: InvitesViewProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class JobCardClick implements BaseEvent {
  event_type = 'job card click';

  constructor(
    public event_properties: JobCardClickProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class JobChatStart implements BaseEvent {
  event_type = 'job chat start';

  constructor(
    public event_properties: JobChatStartProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class JobChatView implements BaseEvent {
  event_type = 'job chat view';

  constructor(
    public event_properties: JobChatViewProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class JobDetailView implements BaseEvent {
  event_type = 'job detail view';

  constructor(
    public event_properties: JobDetailViewProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class JobFilterApply implements BaseEvent {
  event_type = 'job filter apply';

  constructor(
    public event_properties: JobFilterApplyProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class JobFilterClick implements BaseEvent {
  event_type = 'job filter click';

  constructor(
    public event_properties: JobFilterClickProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class JobPostClose implements BaseEvent {
  event_type = 'job post close';

  constructor(
    public event_properties: JobPostCloseProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class JobVisibilityToggle implements BaseEvent {
  event_type = 'job visibility toggle';

  constructor(
    public event_properties: JobVisibilityToggleProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ManageTabView implements BaseEvent {
  event_type = 'manage tab view';

  constructor(
    public event_properties: ManageTabViewProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class MessagesView implements BaseEvent {
  event_type = 'messages view';

  constructor(
    public event_properties: MessagesViewProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class MyMembershipCancel implements BaseEvent {
  event_type = 'my membership cancel';
}

export class MyMembershipManage implements BaseEvent {
  event_type = 'my membership manage';
}

export class MyMembershipView implements BaseEvent {
  event_type = 'my membership view';
}

export class Navigation implements BaseEvent {
  event_type = 'navigation';

  constructor(
    public event_properties: NavigationProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class NewInviteSearchComplete implements BaseEvent {
  event_type = 'new invite search complete';

  constructor(
    public event_properties: NewInviteSearchCompleteProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class NewInviteSearchStart implements BaseEvent {
  event_type = 'new invite search start';

  constructor(
    public event_properties: NewInviteSearchStartProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class NewInviteSuggestedCreative implements BaseEvent {
  event_type = 'new invite suggested creative';

  constructor(
    public event_properties: NewInviteSuggestedCreativeProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class NoAttachedWorkWarning implements BaseEvent {
  event_type = 'no attached work warning';

  constructor(
    public event_properties: NoAttachedWorkWarningProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class NotificationOpen implements BaseEvent {
  event_type = 'notification open';

  constructor(
    public event_properties: NotificationOpenProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PlanSelect implements BaseEvent {
  event_type = 'plan select';

  constructor(
    public event_properties: PlanSelectProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PlanSelectionScreenExit implements BaseEvent {
  event_type = 'plan selection screen exit';

  constructor(
    public event_properties: PlanSelectionScreenExitProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PlanSelectionScreenView implements BaseEvent {
  event_type = 'plan selection screen view';

  constructor(
    public event_properties: PlanSelectionScreenViewProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PostAJobError implements BaseEvent {
  event_type = 'post a job error';

  constructor(
    public event_properties?: PostAJobErrorProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PostAJobExit implements BaseEvent {
  event_type = 'post a job exit';

  constructor(
    public event_properties: PostAJobExitProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PostAJobPublish implements BaseEvent {
  event_type = 'post a job publish';

  constructor(
    public event_properties: PostAJobPublishProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PostAJobSaveDraft implements BaseEvent {
  event_type = 'post a job save draft';

  constructor(
    public event_properties: PostAJobSaveDraftProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PostAJobSetDetail implements BaseEvent {
  event_type = 'post a job set detail';

  constructor(
    public event_properties: PostAJobSetDetailProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PostAJobStart implements BaseEvent {
  event_type = 'post a job start';

  constructor(
    public event_properties: PostAJobStartProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PostAProjectPublish implements BaseEvent {
  event_type = 'post a project publish';

  constructor(
    public event_properties?: PostAProjectPublishProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PostAProjectSetDetail implements BaseEvent {
  event_type = 'post a project set detail';

  constructor(
    public event_properties?: PostAProjectSetDetailProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PostAProjectStart implements BaseEvent {
  event_type = 'post a project start';

  constructor(
    public event_properties: PostAProjectStartProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ProfileAboutView implements BaseEvent {
  event_type = 'profile about view';

  constructor(
    public event_properties?: ProfileAboutViewProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ProfileLinkClick implements BaseEvent {
  event_type = 'profile link click';

  constructor(
    public event_properties: ProfileLinkClickProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ProfileSetupComplete implements BaseEvent {
  event_type = 'profile setup complete';

  constructor(
    public event_properties?: ProfileSetupCompleteProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ProfileSetupStart implements BaseEvent {
  event_type = 'profile setup start';

  constructor(
    public event_properties?: ProfileSetupStartProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ProfileView implements BaseEvent {
  event_type = 'profile view';

  constructor(
    public event_properties?: ProfileViewProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ProjectLike implements BaseEvent {
  event_type = 'project like';

  constructor(
    public event_properties: ProjectLikeProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ProjectView implements BaseEvent {
  event_type = 'project view';

  constructor(
    public event_properties: ProjectViewProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PurchaseSubscriptionStart implements BaseEvent {
  event_type = 'purchase subscription start';

  constructor(
    public event_properties: PurchaseSubscriptionStartProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ReferralRequestAccept implements BaseEvent {
  event_type = 'referral request accept';

  constructor(
    public event_properties: ReferralRequestAcceptProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ReferralRequestIgnore implements BaseEvent {
  event_type = 'referral request ignore';

  constructor(
    public event_properties: ReferralRequestIgnoreProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ReorderWorkComplete implements BaseEvent {
  event_type = 'reorder work complete';
}

export class ScreenView implements BaseEvent {
  event_type = 'screen_view';

  constructor(
    public event_properties?: ScreenViewProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class SelectWorkComplete implements BaseEvent {
  event_type = 'select work complete';
}

export class SelectWorkEdit implements BaseEvent {
  event_type = 'select work edit';
}

export class SelectWorkExit implements BaseEvent {
  event_type = 'select work exit';
}

export class SelectWorkStart implements BaseEvent {
  event_type = 'select work start';
}

export class SignUpComplete implements BaseEvent {
  event_type = 'sign up complete';
}

export class SignUpStart implements BaseEvent {
  event_type = 'sign up start';

  constructor(
    public event_properties: SignUpStartProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class UploadFromVimeoComplete implements BaseEvent {
  event_type = 'upload from vimeo complete';
}

export class UploadFromVimeoStart implements BaseEvent {
  event_type = 'upload from vimeo start';
}

export class UpsellCardClick implements BaseEvent {
  event_type = 'upsell card click';

  constructor(
    public event_properties: UpsellCardClickProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class UpsellModalClickThrough implements BaseEvent {
  event_type = 'upsell modal click through';

  constructor(
    public event_properties: UpsellModalClickThroughProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class UpsellModalExit implements BaseEvent {
  event_type = 'upsell modal exit';

  constructor(
    public event_properties: UpsellModalExitProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class UpsellModalView implements BaseEvent {
  event_type = 'upsell modal view';

  constructor(
    public event_properties: UpsellModalViewProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ViewModeToggle implements BaseEvent {
  event_type = 'view mode toggle';

  constructor(
    public event_properties: ViewModeToggleProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export type PromiseResult<T> = { promise: Promise<T | void> };

const getVoidPromiseResult = () => ({ promise: Promise.resolve() });

// prettier-ignore
export class Ampli {
  private disabled: boolean = false;
  private amplitude?: BrowserClient;

  get client(): BrowserClient {
    this.isInitializedAndEnabled();
    return this.amplitude!;
  }

  get isLoaded(): boolean {
    return this.amplitude != null;
  }

  private isInitializedAndEnabled(): boolean {
    if (!this.amplitude) {
      console.error('ERROR: Ampli is not yet initialized. Have you called ampli.load() on app start?');
      return false;
    }
    return !this.disabled;
  }

  /**
   * Initialize the Ampli SDK. Call once when your application starts.
   *
   * @param options Configuration options to initialize the Ampli SDK with.
   */
  load(options: LoadOptions): PromiseResult<void> {
    this.disabled = options.disabled ?? false;

    if (this.amplitude) {
      console.warn('WARNING: Ampli is already intialized. Ampli.load() should be called once at application startup.');
      return getVoidPromiseResult();
    }

    let apiKey: string | null = null;
    if (options.client && 'apiKey' in options.client) {
      apiKey = options.client.apiKey;
    } else if ('environment' in options) {
      apiKey = ApiKey[options.environment];
    }

    if (options.client && 'instance' in options.client) {
      this.amplitude = options.client.instance;
    } else if (apiKey) {
      this.amplitude = amplitude.createInstance();
      const configuration = (options.client && 'configuration' in options.client) ? options.client.configuration : {};
      return this.amplitude.init(apiKey, undefined, { ...DefaultConfiguration, ...configuration });
    } else {
      console.error("ERROR: ampli.load() requires 'environment', 'client.apiKey', or 'client.instance'");
    }

    return getVoidPromiseResult();
  }

  /**
   * Identify a user and set user properties.
   *
   * @param userId The user's id.
   * @param properties The user properties.
   * @param options Optional event options.
   */
  identify(
    userId: string | undefined,
    properties?: IdentifyProperties,
    options?: EventOptions,
  ): PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    if (userId) {
      options = {...options,  user_id: userId};
    }

    const amplitudeIdentify = new amplitude.Identify();
    const eventProperties = properties;
    if (eventProperties != null) {
      for (const [key, value] of Object.entries(eventProperties)) {
        amplitudeIdentify.set(key, value);
      }
    }
    return this.amplitude!.identify(
      amplitudeIdentify,
      options,
    );
  }

 /**
  * Flush the event.
  */
  flush() : PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    return this.amplitude!.flush();
  }

  /**
   * Track event
   *
   * @param event The event to track.
   * @param options Optional event options.
   */
  track(event: Event, options?: EventOptions): PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    return this.amplitude!.track(event, undefined, options);
  }

  /**
   * account add social cancel
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/account%20add%20social%20cancel)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. account_type)
   * @param options Amplitude event options.
   */
  accountAddSocialCancel(
    properties: AccountAddSocialCancelProperties,
    options?: EventOptions,
  ) {
    return this.track(new AccountAddSocialCancel(properties), options);
  }

  /**
   * account add social complete
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/account%20add%20social%20complete)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. account_type)
   * @param options Amplitude event options.
   */
  accountAddSocialComplete(
    properties: AccountAddSocialCompleteProperties,
    options?: EventOptions,
  ) {
    return this.track(new AccountAddSocialComplete(properties), options);
  }

  /**
   * account add social start
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/account%20add%20social%20start)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. account_type)
   * @param options Amplitude event options.
   */
  accountAddSocialStart(
    properties: AccountAddSocialStartProperties,
    options?: EventOptions,
  ) {
    return this.track(new AccountAddSocialStart(properties), options);
  }

  /**
   * account type choose
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/account%20type%20choose)
   *
   * Triggerd by which button the user clicks on the "how would you like to use NOVA screen"
   *
   * @param properties The event's properties (e.g. action)
   * @param options Amplitude event options.
   */
  accountTypeChoose(
    properties: AccountTypeChooseProperties,
    options?: EventOptions,
  ) {
    return this.track(new AccountTypeChoose(properties), options);
  }

  /**
   * active application open
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/active%20application%20open)
   *
   * Jobs -> Find Work -> My Applications -> Active 
   *  Clicking an active application card to view application details
   *
   * @param properties The event's properties (e.g. job_id)
   * @param options Amplitude event options.
   */
  activeApplicationOpen(
    properties: ActiveApplicationOpenProperties,
    options?: EventOptions,
  ) {
    return this.track(new ActiveApplicationOpen(properties), options);
  }

  /**
   * active job card open
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/active%20job%20card%20open)
   *
   * Jobs -> Hire -> Active jobs 
   *  Clicking an active job post card to open the job management dashboard. This clickable area should not include the shortcut action on the job posting card
   *
   * @param properties The event's properties (e.g. job_id)
   * @param options Amplitude event options.
   */
  activeJobCardOpen(
    properties: ActiveJobCardOpenProperties,
    options?: EventOptions,
  ) {
    return this.track(new ActiveJobCardOpen(properties), options);
  }

  /**
   * active job card shortcut
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/active%20job%20card%20shortcut)
   *
   * Jobs -> Hire -> Active jobs 
   *  Clicking the shortcut component on an active job post card to open the job management dashboard
   *
   * @param properties The event's properties (e.g. job_id)
   * @param options Amplitude event options.
   */
  activeJobCardShortcut(
    properties: ActiveJobCardShortcutProperties,
    options?: EventOptions,
  ) {
    return this.track(new ActiveJobCardShortcut(properties), options);
  }

  /**
   * add proposed rate complete
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/add%20proposed%20rate%20complete)
   *
   * Successfully attaching a proposed rate in the apply to job flow
   *
   * @param options Amplitude event options.
   */
  addProposedRateComplete(
    options?: EventOptions,
  ) {
    return this.track(new AddProposedRateComplete(), options);
  }

  /**
   * add proposed rate exit
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/add%20proposed%20rate%20exit)
   *
   * Clicking the X with the add proposed rate screen open in the apply to job form
   *
   * @param options Amplitude event options.
   */
  addProposedRateExit(
    options?: EventOptions,
  ) {
    return this.track(new AddProposedRateExit(), options);
  }

  /**
   * add proposed rate start
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/add%20proposed%20rate%20start)
   *
   * User opening the Attach your proposed rate on the apply to job form
   *
   * @param options Amplitude event options.
   */
  addProposedRateStart(
    options?: EventOptions,
  ) {
    return this.track(new AddProposedRateStart(), options);
  }

  /**
   * application complete
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/application%20complete)
   *
   * Trigger: Clicking "submit application" button on the review screen
   *
   * @param properties The event's properties (e.g. account_type)
   * @param options Amplitude event options.
   */
  applicationComplete(
    properties?: ApplicationCompleteProperties,
    options?: EventOptions,
  ) {
    return this.track(new ApplicationComplete(properties), options);
  }

  /**
   * application continue
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/application%20continue)
   *
   * Trigger: Clicking "continue application" on the application "in progress" status screen. This screen appears only if the user exited out of the application mid-flow.
   *
   * @param properties The event's properties (e.g. account_type)
   * @param options Amplitude event options.
   */
  applicationContinue(
    properties?: ApplicationContinueProperties,
    options?: EventOptions,
  ) {
    return this.track(new ApplicationContinue(properties), options);
  }

  /**
   * application detail view
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/application%20detail%20view)
   *
   * Job management dashboard -> any of the applicant lists 
   *  Clicking on a user's application card to view the details
   *
   * @param properties The event's properties (e.g. creative_id)
   * @param options Amplitude event options.
   */
  applicationDetailView(
    properties: ApplicationDetailViewProperties,
    options?: EventOptions,
  ) {
    return this.track(new ApplicationDetailView(properties), options);
  }

  /**
   * application edit
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/application%20edit)
   *
   * Clicking to edit your already submitted application
   *
   * @param properties The event's properties (e.g. account_type)
   * @param options Amplitude event options.
   */
  applicationEdit(
    properties?: ApplicationEditProperties,
    options?: EventOptions,
  ) {
    return this.track(new ApplicationEdit(properties), options);
  }

  /**
   * application exit
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/application%20exit)
   *
   * Trigger: Clicking X on any screen in the application flow
   *
   * @param properties The event's properties (e.g. account_type)
   * @param options Amplitude event options.
   */
  applicationExit(
    properties?: ApplicationExitProperties,
    options?: EventOptions,
  ) {
    return this.track(new ApplicationExit(properties), options);
  }

  /**
   * application go to chat
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/application%20go%20to%20chat)
   *
   * Job management dashboard -> any of the applicant lists 
   *  Clicking "go to chat" on a user's application. This should ONLY be triggered on applicants where a chat has already been started. Starting a job chat is captured in "application start a chat"
   *
   * @param properties The event's properties (e.g. creative_id)
   * @param options Amplitude event options.
   */
  applicationGoToChat(
    properties: ApplicationGoToChatProperties,
    options?: EventOptions,
  ) {
    return this.track(new ApplicationGoToChat(properties), options);
  }

  /**
   * application mark interested
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/application%20mark%20interested)
   *
   * Job management dashboard -> any of the applicant lists 
   *  Clicking "interested" on a user's applicant card OR application detail - log that with entry_point property
   *
   * @param properties The event's properties (e.g. creative_id)
   * @param options Amplitude event options.
   */
  applicationMarkInterested(
    properties: ApplicationMarkInterestedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ApplicationMarkInterested(properties), options);
  }

  /**
   * application mark passed
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/application%20mark%20passed)
   *
   * Job management dashboard -> any of the applicant lists 
   *  Clicking "pass" on a user's application
   *
   * @param properties The event's properties (e.g. creative_id)
   * @param options Amplitude event options.
   */
  applicationMarkPassed(
    properties: ApplicationMarkPassedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ApplicationMarkPassed(properties), options);
  }

  /**
   * application set detail
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/application%20set%20detail)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. step)
   * @param options Amplitude event options.
   */
  applicationSetDetail(
    properties: ApplicationSetDetailProperties,
    options?: EventOptions,
  ) {
    return this.track(new ApplicationSetDetail(properties), options);
  }

  /**
   * application start
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/application%20start)
   *
   * Trigger: Clicking "start application" on the application status screen. This same event is used to track conversion of application flows for both the client and creative hub. Segment on interface to see the distinct calls based on the interface
   *
   * @param properties The event's properties (e.g. account_type)
   * @param options Amplitude event options.
   */
  applicationStart(
    properties?: ApplicationStartProperties,
    options?: EventOptions,
  ) {
    return this.track(new ApplicationStart(properties), options);
  }

  /**
   * application start a chat
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/application%20start%20a%20chat)
   *
   * Job management dashboard -> any of the applicant lists Clicking "start a chat" on a user's application. This should be triggered on the button click. A job chat actually being created should trigger "job chat start"
   *
   * @param properties The event's properties (e.g. creative_id)
   * @param options Amplitude event options.
   */
  applicationStartAChat(
    properties: ApplicationStartAChatProperties,
    options?: EventOptions,
  ) {
    return this.track(new ApplicationStartAChat(properties), options);
  }

  /**
   * application unmark interested
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/application%20unmark%20interested)
   *
   * Job management dashboard -> any of the applicant lists 
   *  De-selecting "interested" on a user's application
   *
   * @param properties The event's properties (e.g. creative_id)
   * @param options Amplitude event options.
   */
  applicationUnmarkInterested(
    properties: ApplicationUnmarkInterestedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ApplicationUnmarkInterested(properties), options);
  }

  /**
   * application unmark passed
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/application%20unmark%20passed)
   *
   * Job management dashboard -> any of the applicant lists 
   *  De-selecting "passed" on a user's application
   *
   * @param properties The event's properties (e.g. creative_id)
   * @param options Amplitude event options.
   */
  applicationUnmarkPassed(
    properties: ApplicationUnmarkPassedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ApplicationUnmarkPassed(properties), options);
  }

  /**
   * applications view
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/applications%20view)
   *
   * Jobs -> Hire -> Active Jobs -> Job management dashboard 
   *  Clicking one of the shortcuts to view a certain list within applications. The shortcuts that are surfaced are dependent on what the job status is
   *
   * @param properties The event's properties (e.g. job_id)
   * @param options Amplitude event options.
   */
  applicationsView(
    properties: ApplicationsViewProperties,
    options?: EventOptions,
  ) {
    return this.track(new ApplicationsView(properties), options);
  }

  /**
   * apply to job complete
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/apply%20to%20job%20complete)
   *
   * Trigger: User clicks "apply" and sees toast that their application was sent successfully. This event should not be triggered until that confirmation is sent to the user.
   *
   * @param properties The event's properties (e.g. job_id)
   * @param options Amplitude event options.
   */
  applyToJobComplete(
    properties: ApplyToJobCompleteProperties,
    options?: EventOptions,
  ) {
    return this.track(new ApplyToJobComplete(properties), options);
  }

  /**
   * apply to job exit
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/apply%20to%20job%20exit)
   *
   * Clicking X on the apply to job page to exit before completion
   *
   * @param options Amplitude event options.
   */
  applyToJobExit(
    options?: EventOptions,
  ) {
    return this.track(new ApplyToJobExit(), options);
  }

  /**
   * apply to job start
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/apply%20to%20job%20start)
   *
   * Trigger: User clicks "apply to job" on either of the two potential entry points 1) the job detail screen 2) the job invitation screen
   *
   * @param properties The event's properties (e.g. job_id)
   * @param options Amplitude event options.
   */
  applyToJobStart(
    properties: ApplyToJobStartProperties,
    options?: EventOptions,
  ) {
    return this.track(new ApplyToJobStart(properties), options);
  }

  /**
   * archived application open
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/archived%20application%20open)
   *
   * Jobs -> Find Work -> My Applications -> Archived 
   *  Clicking an archived application card to view application details
   *
   * @param properties The event's properties (e.g. job_id)
   * @param options Amplitude event options.
   */
  archivedApplicationOpen(
    properties: ArchivedApplicationOpenProperties,
    options?: EventOptions,
  ) {
    return this.track(new ArchivedApplicationOpen(properties), options);
  }

  /**
   * benefits modal interaction
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/benefits%20modal%20interaction)
   *
   * User interacting with the modal after the purchase flow that explains the benefits of the subscription
   *
   * @param properties The event's properties (e.g. action)
   * @param options Amplitude event options.
   */
  benefitsModalInteraction(
    properties: BenefitsModalInteractionProperties,
    options?: EventOptions,
  ) {
    return this.track(new BenefitsModalInteraction(properties), options);
  }

  /**
   * business card view more work
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/business%20card%20view%20more%20work)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. entry_point)
   * @param options Amplitude event options.
   */
  businessCardViewMoreWork(
    properties: BusinessCardViewMoreWorkProperties,
    options?: EventOptions,
  ) {
    return this.track(new BusinessCardViewMoreWork(properties), options);
  }

  /**
   * business card view profile
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/business%20card%20view%20profile)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. entry_point)
   * @param options Amplitude event options.
   */
  businessCardViewProfile(
    properties: BusinessCardViewProfileProperties,
    options?: EventOptions,
  ) {
    return this.track(new BusinessCardViewProfile(properties), options);
  }

  /**
   * chat message send
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/chat%20message%20send)
   *
   * Trigger: Typing a message in a chat window and clicking the send button
   *
   * @param properties The event's properties (e.g. account_type)
   * @param options Amplitude event options.
   */
  chatMessageSend(
    properties: ChatMessageSendProperties,
    options?: EventOptions,
  ) {
    return this.track(new ChatMessageSend(properties), options);
  }

  /**
   * chat start
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/chat%20start)
   *
   * Trigger: User clicks message on a creative profile, inputs a message, and the event is triggered when they hit "send"
   *
   * @param properties The event's properties (e.g. account_type)
   * @param options Amplitude event options.
   */
  chatStart(
    properties: ChatStartProperties,
    options?: EventOptions,
  ) {
    return this.track(new ChatStart(properties), options);
  }

  /**
   * connection request accept
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/connection%20request%20accept)
   *
   * Trigger: User accepts a connection request. There are multiple entry points that could trigger this event, so look at the entry point property to see these.
   *
   * @param properties The event's properties (e.g. entry_point)
   * @param options Amplitude event options.
   */
  connectionRequestAccept(
    properties: ConnectionRequestAcceptProperties,
    options?: EventOptions,
  ) {
    return this.track(new ConnectionRequestAccept(properties), options);
  }

  /**
   * connection request send
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/connection%20request%20send)
   *
   * Trigger: User clicks connect button attached to a user. There are a number of different entry points for this event to be triggered, see the assocaited property to view these.
   *
   * @param properties The event's properties (e.g. entry_point)
   * @param options Amplitude event options.
   */
  connectionRequestSend(
    properties: ConnectionRequestSendProperties,
    options?: EventOptions,
  ) {
    return this.track(new ConnectionRequestSend(properties), options);
  }

  /**
   * details tab view
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/details%20tab%20view)
   *
   * Job management dashboard
   *
   * * iOS: Switching tabs into the details tab 
   *
   * * Web: Clicking "view details" to open about modal
   *
   * @param properties The event's properties (e.g. job_id)
   * @param options Amplitude event options.
   */
  detailsTabView(
    properties: DetailsTabViewProperties,
    options?: EventOptions,
  ) {
    return this.track(new DetailsTabView(properties), options);
  }

  /**
   * discover category view all
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/discover%20category%20view%20all)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. shortcut_type)
   * @param options Amplitude event options.
   */
  discoverCategoryViewAll(
    properties: DiscoverCategoryViewAllProperties,
    options?: EventOptions,
  ) {
    return this.track(new DiscoverCategoryViewAll(properties), options);
  }

  /**
   * discover filter apply
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/discover%20filter%20apply)
   *
   * Trigger: Applying a filter on one of the category detail pages.
   *
   * @param properties The event's properties (e.g. entry_point)
   * @param options Amplitude event options.
   */
  discoverFilterApply(
    properties: DiscoverFilterApplyProperties,
    options?: EventOptions,
  ) {
    return this.track(new DiscoverFilterApply(properties), options);
  }

  /**
   * discover keyword search
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/discover%20keyword%20search)
   *
   * Trigger: Clicking the search button on keyboard after typing in a search term in the search bar on the discover page. 
   *
   *
   * Note: The search process begins before the "search" button is clicked, so many searches won't register if a user clicks into a  result before they click "search"
   *
   * @param properties The event's properties (e.g. account_type)
   * @param options Amplitude event options.
   */
  discoverKeywordSearch(
    properties?: DiscoverKeywordSearchProperties,
    options?: EventOptions,
  ) {
    return this.track(new DiscoverKeywordSearch(properties), options);
  }

  /**
   * discover results view toggle
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/discover%20results%20view%20toggle)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. from)
   * @param options Amplitude event options.
   */
  discoverResultsViewToggle(
    properties: DiscoverResultsViewToggleProperties,
    options?: EventOptions,
  ) {
    return this.track(new DiscoverResultsViewToggle(properties), options);
  }

  /**
   * discover shortcut search
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/discover%20shortcut%20search)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. shortcut_type)
   * @param options Amplitude event options.
   */
  discoverShortcutSearch(
    properties: DiscoverShortcutSearchProperties,
    options?: EventOptions,
  ) {
    return this.track(new DiscoverShortcutSearch(properties), options);
  }

  /**
   * email notification link click
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/email%20notification%20link%20click)
   *
   * When the user clicks a link in the email notification that returns them to the platform
   *
   * @param properties The event's properties (e.g. link_type)
   * @param options Amplitude event options.
   */
  emailNotificationLinkClick(
    properties: EmailNotificationLinkClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new EmailNotificationLinkClick(properties), options);
  }

  /**
   * email notification open
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/email%20notification%20open)
   *
   * When the user opens an email notification
   *
   * @param properties The event's properties (e.g. notification_id)
   * @param options Amplitude event options.
   */
  emailNotificationOpen(
    properties: EmailNotificationOpenProperties,
    options?: EventOptions,
  ) {
    return this.track(new EmailNotificationOpen(properties), options);
  }

  /**
   * entry action choose
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/entry%20action%20choose)
   *
   * Clicking on one of the options at the end of the user onboarding flow when prompted with "where do you want to start"
   *
   * @param properties The event's properties (e.g. action)
   * @param options Amplitude event options.
   */
  entryActionChoose(
    properties: EntryActionChooseProperties,
    options?: EventOptions,
  ) {
    return this.track(new EntryActionChoose(properties), options);
  }

  /**
   * featured list view
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/featured%20list%20view)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. entry_point)
   * @param options Amplitude event options.
   */
  featuredListView(
    properties: FeaturedListViewProperties,
    options?: EventOptions,
  ) {
    return this.track(new FeaturedListView(properties), options);
  }

  /**
   * invite to job complete
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/invite%20to%20job%20complete)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. account_type)
   * @param options Amplitude event options.
   */
  inviteToJobComplete(
    properties: InviteToJobCompleteProperties,
    options?: EventOptions,
  ) {
    return this.track(new InviteToJobComplete(properties), options);
  }

  /**
   * invite to job exit
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/invite%20to%20job%20exit)
   *
   * trigger: clicking X out of the invite to job flow
   *
   * @param properties The event's properties (e.g. account_type)
   * @param options Amplitude event options.
   */
  inviteToJobExit(
    properties: InviteToJobExitProperties,
    options?: EventOptions,
  ) {
    return this.track(new InviteToJobExit(properties), options);
  }

  /**
   * invite to job start
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/invite%20to%20job%20start)
   *
   * triggered by clicking invite to job on creative's profile
   *
   * @param properties The event's properties (e.g. account_type)
   * @param options Amplitude event options.
   */
  inviteToJobStart(
    properties: InviteToJobStartProperties,
    options?: EventOptions,
  ) {
    return this.track(new InviteToJobStart(properties), options);
  }

  /**
   * invites view
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/invites%20view)
   *
   * Jobs -> Hire -> Active Jobs -> Job management dashboard 
   *  Clicking on invites section to view your invitations
   *
   * @param properties The event's properties (e.g. job_id)
   * @param options Amplitude event options.
   */
  invitesView(
    properties: InvitesViewProperties,
    options?: EventOptions,
  ) {
    return this.track(new InvitesView(properties), options);
  }

  /**
   * job card click
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/job%20card%20click)
   *
   * Clicking on a job card on the job board
   *
   * @param properties The event's properties (e.g. job_id)
   * @param options Amplitude event options.
   */
  jobCardClick(
    properties: JobCardClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new JobCardClick(properties), options);
  }

  /**
   * job chat start
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/job%20chat%20start)
   *
   * Trigger: Clicking "start chat" after typing out a message to send to an applicant
   *
   * @param properties The event's properties (e.g. account_type)
   * @param options Amplitude event options.
   */
  jobChatStart(
    properties: JobChatStartProperties,
    options?: EventOptions,
  ) {
    return this.track(new JobChatStart(properties), options);
  }

  /**
   * job chat view
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/job%20chat%20view)
   *
   * Job management dashboard -> Messages 
   *  Clicking into a job chat in the list
   *
   * @param properties The event's properties (e.g. creative_id)
   * @param options Amplitude event options.
   */
  jobChatView(
    properties: JobChatViewProperties,
    options?: EventOptions,
  ) {
    return this.track(new JobChatView(properties), options);
  }

  /**
   * job detail view
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/job%20detail%20view)
   *
   * This event should be triggered whenever the user lands on a job detail screen. Using a screen view for this isn't sufficient because we want to track the job id with this event being fired.
   *
   * @param properties The event's properties (e.g. entry_point)
   * @param options Amplitude event options.
   */
  jobDetailView(
    properties: JobDetailViewProperties,
    options?: EventOptions,
  ) {
    return this.track(new JobDetailView(properties), options);
  }

  /**
   * job filter apply
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/job%20filter%20apply)
   *
   * Trigger: User selects a filter on the job feed and clicks "apply"
   *
   * @param properties The event's properties (e.g. filter_type)
   * @param options Amplitude event options.
   */
  jobFilterApply(
    properties: JobFilterApplyProperties,
    options?: EventOptions,
  ) {
    return this.track(new JobFilterApply(properties), options);
  }

  /**
   * job filter click
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/job%20filter%20click)
   *
   * Triggered by clicking on one of the pill filters. This should be triggered regardless of if the user is a pro user or not
   *
   * @param properties The event's properties (e.g. filter_type)
   * @param options Amplitude event options.
   */
  jobFilterClick(
    properties: JobFilterClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new JobFilterClick(properties), options);
  }

  /**
   * job post close
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/job%20post%20close)
   *
   * Trigger: User opens the job post management and clicks close job posting
   *
   * @param properties The event's properties (e.g. account_type)
   * @param options Amplitude event options.
   */
  jobPostClose(
    properties: JobPostCloseProperties,
    options?: EventOptions,
  ) {
    return this.track(new JobPostClose(properties), options);
  }

  /**
   * job visibility toggle
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/job%20visibility%20toggle)
   *
   * job management dashboard -> manage tab 
   *
   * * iOS: clicking to toggle visibility of the job post
   *
   * * Web: clicking to toggle visibility of the job post
   *
   * @param properties The event's properties (e.g. action)
   * @param options Amplitude event options.
   */
  jobVisibilityToggle(
    properties: JobVisibilityToggleProperties,
    options?: EventOptions,
  ) {
    return this.track(new JobVisibilityToggle(properties), options);
  }

  /**
   * manage tab view
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/manage%20tab%20view)
   *
   * Job management dashboard 
   *  Switching tabs into the manage tab
   *
   * @param properties The event's properties (e.g. job_id)
   * @param options Amplitude event options.
   */
  manageTabView(
    properties: ManageTabViewProperties,
    options?: EventOptions,
  ) {
    return this.track(new ManageTabView(properties), options);
  }

  /**
   * messages view
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/messages%20view)
   *
   * Jobs -> Hire -> Active Jobs -> Job management dashboard 
   *  Clicking messages shortcut to open the section screen with all open job chats.
   *
   * @param properties The event's properties (e.g. job_id)
   * @param options Amplitude event options.
   */
  messagesView(
    properties: MessagesViewProperties,
    options?: EventOptions,
  ) {
    return this.track(new MessagesView(properties), options);
  }

  /**
   * my membership cancel
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/my%20membership%20cancel)
   *
   * My stuff -> My Pro Membership 
   *  Clicling on the "cancel subscription" button
   *
   * @param options Amplitude event options.
   */
  myMembershipCancel(
    options?: EventOptions,
  ) {
    return this.track(new MyMembershipCancel(), options);
  }

  /**
   * my membership manage
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/my%20membership%20manage)
   *
   * Clicking on the manage subscription section in the "my pro membership" page
   *
   * @param options Amplitude event options.
   */
  myMembershipManage(
    options?: EventOptions,
  ) {
    return this.track(new MyMembershipManage(), options);
  }

  /**
   * my membership view
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/my%20membership%20view)
   *
   * Clicking on the "my pro subscription" section in My Stuff
   *
   * @param options Amplitude event options.
   */
  myMembershipView(
    options?: EventOptions,
  ) {
    return this.track(new MyMembershipView(), options);
  }

  /**
   * navigation
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/navigation)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. account_type)
   * @param options Amplitude event options.
   */
  navigation(
    properties: NavigationProperties,
    options?: EventOptions,
  ) {
    return this.track(new Navigation(properties), options);
  }

  /**
   * new invite search complete
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/new%20invite%20search%20complete)
   *
   * Job management dashboard -> Invites
   *
   * * ios: Clicking "send invite" after selecting a user to invite
   *
   * * web: clicking "invite to job" inside the search modal to successfully invite a creative
   *
   * @param properties The event's properties (e.g. job_id)
   * @param options Amplitude event options.
   */
  newInviteSearchComplete(
    properties: NewInviteSearchCompleteProperties,
    options?: EventOptions,
  ) {
    return this.track(new NewInviteSearchComplete(properties), options);
  }

  /**
   * new invite search start
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/new%20invite%20search%20start)
   *
   * Job management dashboard -> Invites
   *
   * * iOS: Clicking the "Have someone in mind? Find a creative to invite" component
   *
   * * Web: clicking the "+ invite someone" button
   *
   * @param properties The event's properties (e.g. job_id)
   * @param options Amplitude event options.
   */
  newInviteSearchStart(
    properties: NewInviteSearchStartProperties,
    options?: EventOptions,
  ) {
    return this.track(new NewInviteSearchStart(properties), options);
  }

  /**
   * new invite suggested creative
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/new%20invite%20suggested%20creative)
   *
   * * This should be triggered whenever a suggested user is successfully invited to a job within the swipe modal. 
   *
   * * For iOS, this event will be triggered in conjunction with "invite to job swipe" if the user swipes right to invite the suggested creative
   *
   * * Web: using the one-tap invite feature to invite a suggested creative inside the invites page. Clicking "invite to job" button
   *
   * @param properties The event's properties (e.g. entry_point)
   * @param options Amplitude event options.
   */
  newInviteSuggestedCreative(
    properties: NewInviteSuggestedCreativeProperties,
    options?: EventOptions,
  ) {
    return this.track(new NewInviteSuggestedCreative(properties), options);
  }

  /**
   * no attached work warning
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/no%20attached%20work%20warning)
   *
   * This is triggered by the user interacting with the warning that is shown when they try to submit an application without attaching any projects
   *
   *
   * The action property values should be "attach work" or "dismiss"
   *
   * @param properties The event's properties (e.g. action)
   * @param options Amplitude event options.
   */
  noAttachedWorkWarning(
    properties: NoAttachedWorkWarningProperties,
    options?: EventOptions,
  ) {
    return this.track(new NoAttachedWorkWarning(properties), options);
  }

  /**
   * notification open
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/notification%20open)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. notification_type)
   * @param options Amplitude event options.
   */
  notificationOpen(
    properties: NotificationOpenProperties,
    options?: EventOptions,
  ) {
    return this.track(new NotificationOpen(properties), options);
  }

  /**
   * plan select
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/plan%20select)
   *
   * Clicking on one of the plan components
   *
   * @param properties The event's properties (e.g. free_trial)
   * @param options Amplitude event options.
   */
  planSelect(
    properties: PlanSelectProperties,
    options?: EventOptions,
  ) {
    return this.track(new PlanSelect(properties), options);
  }

  /**
   * plan selection screen exit
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/plan%20selection%20screen%20exit)
   *
   * Exiting out of the purchase screen
   *
   * @param properties The event's properties (e.g. entry_point)
   * @param options Amplitude event options.
   */
  planSelectionScreenExit(
    properties: PlanSelectionScreenExitProperties,
    options?: EventOptions,
  ) {
    return this.track(new PlanSelectionScreenExit(properties), options);
  }

  /**
   * plan selection screen view
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/plan%20selection%20screen%20view)
   *
   * User landing on the purchase screen where the tiers are presented to them
   *
   * @param properties The event's properties (e.g. entry_point)
   * @param options Amplitude event options.
   */
  planSelectionScreenView(
    properties: PlanSelectionScreenViewProperties,
    options?: EventOptions,
  ) {
    return this.track(new PlanSelectionScreenView(properties), options);
  }

  /**
   * post a job error
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/post%20a%20job%20error)
   *
   * Trigger: whenever an error is shown on the post a job flow from a required field not being inputted
   *
   * @param properties The event's properties (e.g. account_type)
   * @param options Amplitude event options.
   */
  postAJobError(
    properties?: PostAJobErrorProperties,
    options?: EventOptions,
  ) {
    return this.track(new PostAJobError(properties), options);
  }

  /**
   * post a job exit
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/post%20a%20job%20exit)
   *
   * Trigger: Clicking X in the top right corner of the post a job flow
   *
   * @param properties The event's properties (e.g. account_type)
   * @param options Amplitude event options.
   */
  postAJobExit(
    properties: PostAJobExitProperties,
    options?: EventOptions,
  ) {
    return this.track(new PostAJobExit(properties), options);
  }

  /**
   * post a job publish
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/post%20a%20job%20publish)
   *
   * Trigger: User clicks publish job and sees toast that the job was successfully published. This event should not be triggered until that confirmation is sent to the user.
   *
   * @param properties The event's properties (e.g. account_type)
   * @param options Amplitude event options.
   */
  postAJobPublish(
    properties: PostAJobPublishProperties,
    options?: EventOptions,
  ) {
    return this.track(new PostAJobPublish(properties), options);
  }

  /**
   * post a job save draft
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/post%20a%20job%20save%20draft)
   *
   * Trigger: Clicking "save as a draft" on the review screen of the post a job flow
   *
   * @param properties The event's properties (e.g. account_type)
   * @param options Amplitude event options.
   */
  postAJobSaveDraft(
    properties: PostAJobSaveDraftProperties,
    options?: EventOptions,
  ) {
    return this.track(new PostAJobSaveDraft(properties), options);
  }

  /**
   * post a job set detail
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/post%20a%20job%20set%20detail)
   *
   * Trigger: Clicking done on any of the components that adds a piece of information to the job post
   *
   * @param properties The event's properties (e.g. account_type)
   * @param options Amplitude event options.
   */
  postAJobSetDetail(
    properties: PostAJobSetDetailProperties,
    options?: EventOptions,
  ) {
    return this.track(new PostAJobSetDetail(properties), options);
  }

  /**
   * post a job start
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/post%20a%20job%20start)
   *
   * Trigger: Clicking on one of the entry points to enter the post a job flow. Entry points include 1) The + icon on the job feed 2) The + icon on in my stuff -> my job postings 3) In the future, the post a job shortcut at the top of the job feed
   *
   * @param properties The event's properties (e.g. account_type)
   * @param options Amplitude event options.
   */
  postAJobStart(
    properties: PostAJobStartProperties,
    options?: EventOptions,
  ) {
    return this.track(new PostAJobStart(properties), options);
  }

  /**
   * post a project publish
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/post%20a%20project%20publish)
   *
   * This event should not be triggered until the user sees that their project has been published successfully via the toast
   *
   * @param properties The event's properties (e.g. project_id)
   * @param options Amplitude event options.
   */
  postAProjectPublish(
    properties?: PostAProjectPublishProperties,
    options?: EventOptions,
  ) {
    return this.track(new PostAProjectPublish(properties), options);
  }

  /**
   * post a project set detail
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/post%20a%20project%20set%20detail)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. field)
   * @param options Amplitude event options.
   */
  postAProjectSetDetail(
    properties?: PostAProjectSetDetailProperties,
    options?: EventOptions,
  ) {
    return this.track(new PostAProjectSetDetail(properties), options);
  }

  /**
   * post a project start
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/post%20a%20project%20start)
   *
   * Trigger: clicking + new project on the my stuff landing screen. In the future there will be multiple entry points to trigger this event, so keep an eye on the entry point property
   *
   * @param properties The event's properties (e.g. entry_point)
   * @param options Amplitude event options.
   */
  postAProjectStart(
    properties: PostAProjectStartProperties,
    options?: EventOptions,
  ) {
    return this.track(new PostAProjectStart(properties), options);
  }

  /**
   * profile about view
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/profile%20about%20view)
   *
   * Trigger: Navigating to the about tab on any creative's profile other than own.
   *
   * @param properties The event's properties (e.g. account_type)
   * @param options Amplitude event options.
   */
  profileAboutView(
    properties?: ProfileAboutViewProperties,
    options?: EventOptions,
  ) {
    return this.track(new ProfileAboutView(properties), options);
  }

  /**
   * profile link click
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/profile%20link%20click)
   *
   * Trigger: clicking a connected social on the profile that takes you away from the app
   *
   * @param properties The event's properties (e.g. account_type)
   * @param options Amplitude event options.
   */
  profileLinkClick(
    properties: ProfileLinkClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new ProfileLinkClick(properties), options);
  }

  /**
   * profile setup complete
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/profile%20setup%20complete)
   *
   * Trigge: Clicking "done" on the last screen of the profile setup flow
   *
   * @param properties The event's properties (e.g. account_type)
   * @param options Amplitude event options.
   */
  profileSetupComplete(
    properties?: ProfileSetupCompleteProperties,
    options?: EventOptions,
  ) {
    return this.track(new ProfileSetupComplete(properties), options);
  }

  /**
   * profile setup start
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/profile%20setup%20start)
   *
   * Trigger: Click get started on the  application acceptance screen. If the user is in the creative hub, this triggers the creation of the creative entity in the backend and assigns the creative id user property. If the user is in the client hub, this triggers the creatiion of the client entity and assigns the client id user property.
   *
   * @param properties The event's properties (e.g. account_type)
   * @param options Amplitude event options.
   */
  profileSetupStart(
    properties?: ProfileSetupStartProperties,
    options?: EventOptions,
  ) {
    return this.track(new ProfileSetupStart(properties), options);
  }

  /**
   * profile view
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/profile%20view)
   *
   * Trigger: Landing on any creative's profile other than own. This automatically lands on the Work tab.
   *
   * @param properties The event's properties (e.g. account_type)
   * @param options Amplitude event options.
   */
  profileView(
    properties?: ProfileViewProperties,
    options?: EventOptions,
  ) {
    return this.track(new ProfileView(properties), options);
  }

  /**
   * project like
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/project%20like)
   *
   * Trigger: Clicking the like icon the project details screen
   *
   * @param properties The event's properties (e.g. account_type)
   * @param options Amplitude event options.
   */
  projectLike(
    properties: ProjectLikeProperties,
    options?: EventOptions,
  ) {
    return this.track(new ProjectLike(properties), options);
  }

  /**
   * project view
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/project%20view)
   *
   * Trigger: User lands on a project detail screen that isn't their own
   *
   * @param properties The event's properties (e.g. account_type)
   * @param options Amplitude event options.
   */
  projectView(
    properties: ProjectViewProperties,
    options?: EventOptions,
  ) {
    return this.track(new ProjectView(properties), options);
  }

  /**
   * purchase subscription start
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/purchase%20subscription%20start)
   *
   * Clicking "unlock pro" button after selecting the desired tier
   *
   * @param properties The event's properties (e.g. free_trial)
   * @param options Amplitude event options.
   */
  purchaseSubscriptionStart(
    properties: PurchaseSubscriptionStartProperties,
    options?: EventOptions,
  ) {
    return this.track(new PurchaseSubscriptionStart(properties), options);
  }

  /**
   * referral request accept
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/referral%20request%20accept)
   *
   * User accepting a referral request
   *
   * @param properties The event's properties (e.g. entry_point)
   * @param options Amplitude event options.
   */
  referralRequestAccept(
    properties: ReferralRequestAcceptProperties,
    options?: EventOptions,
  ) {
    return this.track(new ReferralRequestAccept(properties), options);
  }

  /**
   * referral request ignore
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/referral%20request%20ignore)
   *
   * User ignoring a referral request
   *
   * @param properties The event's properties (e.g. entry_point)
   * @param options Amplitude event options.
   */
  referralRequestIgnore(
    properties: ReferralRequestIgnoreProperties,
    options?: EventOptions,
  ) {
    return this.track(new ReferralRequestIgnore(properties), options);
  }

  /**
   * reorder work complete
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/reorder%20work%20complete)
   *
   * Trigger: Clicking "Done" at the top of the My Work screen after atleast one project has been re-ordered
   *
   * @param options Amplitude event options.
   */
  reorderWorkComplete(
    options?: EventOptions,
  ) {
    return this.track(new ReorderWorkComplete(), options);
  }

  /**
   * screen_view
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/screen_view)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. account_type)
   * @param options Amplitude event options.
   */
  screenView(
    properties?: ScreenViewProperties,
    options?: EventOptions,
  ) {
    return this.track(new ScreenView(properties), options);
  }

  /**
   * select work complete
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/select%20work%20complete)
   *
   * Clicking "done" in the select work modal
   *
   * @param options Amplitude event options.
   */
  selectWorkComplete(
    options?: EventOptions,
  ) {
    return this.track(new SelectWorkComplete(), options);
  }

  /**
   * select work edit
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/select%20work%20edit)
   *
   * Clicking "edit" on work selection component to re-open select work modal
   *
   * @param options Amplitude event options.
   */
  selectWorkEdit(
    options?: EventOptions,
  ) {
    return this.track(new SelectWorkEdit(), options);
  }

  /**
   * select work exit
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/select%20work%20exit)
   *
   * Clicking back arrow in the select work modal
   *
   * @param options Amplitude event options.
   */
  selectWorkExit(
    options?: EventOptions,
  ) {
    return this.track(new SelectWorkExit(), options);
  }

  /**
   * select work start
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/select%20work%20start)
   *
   * Clicking select work on the apply to job page
   *
   * @param options Amplitude event options.
   */
  selectWorkStart(
    options?: EventOptions,
  ) {
    return this.track(new SelectWorkStart(), options);
  }

  /**
   * sign up complete
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/sign%20up%20complete)
   *
   * Trigger: Landing on the creative vs. client hub screen for the first time. This marks completing the sign up flow successfully.
   *
   * @param options Amplitude event options.
   */
  signUpComplete(
    options?: EventOptions,
  ) {
    return this.track(new SignUpComplete(), options);
  }

  /**
   * sign up start
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/sign%20up%20start)
   *
   * Trigger: Clicking one of the two sign up buttons on the app homepage
   *
   * @param properties The event's properties (e.g. sign_up_method)
   * @param options Amplitude event options.
   */
  signUpStart(
    properties: SignUpStartProperties,
    options?: EventOptions,
  ) {
    return this.track(new SignUpStart(properties), options);
  }

  /**
   * upload from vimeo complete
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/upload%20from%20vimeo%20complete)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  uploadFromVimeoComplete(
    options?: EventOptions,
  ) {
    return this.track(new UploadFromVimeoComplete(), options);
  }

  /**
   * upload from vimeo start
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/upload%20from%20vimeo%20start)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  uploadFromVimeoStart(
    options?: EventOptions,
  ) {
    return this.track(new UploadFromVimeoStart(), options);
  }

  /**
   * upsell card click
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/upsell%20card%20click)
   *
   * User proactively clicking on one of our Pro subscription upsell banners
   *
   * @param properties The event's properties (e.g. entry_point)
   * @param options Amplitude event options.
   */
  upsellCardClick(
    properties: UpsellCardClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new UpsellCardClick(properties), options);
  }

  /**
   * upsell modal click through
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/upsell%20modal%20click%20through)
   *
   * User clicks "Upgrade to Pro" button in upsell modal to continue onto the purchase page
   *
   * @param properties The event's properties (e.g. entry_point)
   * @param options Amplitude event options.
   */
  upsellModalClickThrough(
    properties: UpsellModalClickThroughProperties,
    options?: EventOptions,
  ) {
    return this.track(new UpsellModalClickThrough(properties), options);
  }

  /**
   * upsell modal exit
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/upsell%20modal%20exit)
   *
   * User clicks X on upsell modal to exit out of it
   *
   * @param properties The event's properties (e.g. entry_point)
   * @param options Amplitude event options.
   */
  upsellModalExit(
    properties: UpsellModalExitProperties,
    options?: EventOptions,
  ) {
    return this.track(new UpsellModalExit(properties), options);
  }

  /**
   * upsell modal view
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/upsell%20modal%20view)
   *
   * User is shown an upsell modal based on some action that was taken
   *
   * @param properties The event's properties (e.g. entry_point)
   * @param options Amplitude event options.
   */
  upsellModalView(
    properties: UpsellModalViewProperties,
    options?: EventOptions,
  ) {
    return this.track(new UpsellModalView(properties), options);
  }

  /**
   * view mode toggle
   *
   * [View in Tracking Plan](https://data.amplitude.com/novantwrk/NOVA/events/main/latest/view%20mode%20toggle)
   *
   * Job management dashboard -> Unreviewed applications  
   *  Changing the application view mode by clicking the icon in the top right corner
   *
   * @param properties The event's properties (e.g. action)
   * @param options Amplitude event options.
   */
  viewModeToggle(
    properties: ViewModeToggleProperties,
    options?: EventOptions,
  ) {
    return this.track(new ViewModeToggle(properties), options);
  }
}

export const ampli = new Ampli();

// BASE TYPES
type BrowserOptions = amplitude.Types.BrowserOptions;

export type BrowserClient = amplitude.Types.BrowserClient;
export type BaseEvent = amplitude.Types.BaseEvent;
export type IdentifyEvent = amplitude.Types.IdentifyEvent;
export type GroupEvent = amplitude.Types.GroupIdentifyEvent;
export type Event = amplitude.Types.Event;
export type EventOptions = amplitude.Types.EventOptions;
export type Result = amplitude.Types.Result;
